import { useRouter } from 'next/navigation';
import { type MouseEvent, useCallback } from 'react';

import type { GameV1 } from '@/api/games';
import { isGamePage } from '@/helpers/game';
import { Modals } from '@/helpers/modals';
import { usePlayerFieldsStatus } from '@/hooks/usePlayerFieldsStatus';
import { useGetCommonStore, useModalsStore } from '@/store';

export const useGameDemoAction = (
  game?: GameV1,
  onDemoClick?: (game: GameV1) => void
) => {
  const useCommonStore = useGetCommonStore();

  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const { push } = useRouter();
  const open = useModalsStore.use.open();
  const { missingFields } = usePlayerFieldsStatus(game?.provider);

  const handleDemo = useCallback(
    (event: MouseEvent) => {
      if (!game) return;

      onDemoClick && onDemoClick(game);

      if (!isGamePage(window.location.pathname)) {
        useCommonStore.setState({
          gameOpenBackUrl: window.location.href,
        });
      }

      if (isAuthenticated && missingFields.length) {
        event.preventDefault();
        open(Modals.CompleteProfile, {
          customOnClose: () => {
            push(encodeURI(`/game/${game.fullPath}/?demo=true`));
          },
        });
        return;
      }
    },
    [game, onDemoClick, isAuthenticated, missingFields.length, open, push]
  );

  return handleDemo;
};
